<template>
    <modal id="under-16">
        <div class="page-title">Under 16?</div>

        <p class="my-4">We do not treat anyone under the age of 8, however, if the patient is between 9 and 16 years old, please call us on <a style="text-decoration: underline" href="tel:+443306780850">0330 678 0850</a> to book your appointment. Please note that a parent or guardian will need to accompany the patient to their appointment</p>

        <hr />

        <div class="text-center">
            <a href="#" @click.prevent="hideModal" class="btn btn-secondary">Close</a>
        </div>
    </modal>
</template>

<script>
    import Modal from '../../Global/Modal';

    export default {
        name: 'under-16',

        components: {
            Modal,
        },
    }
</script>
